import { ReactComponent as AssetRiskIcon } from 'src/assets/RiskReport_images/assetRiskIcon.svg'
import { ReactComponent as HrRiskIcon } from 'src/assets/RiskReport_images/hrRiskIcon.svg'
import { ReactComponent as DirectorInsuranceIcon } from 'src/assets/RiskReport_images/directorInsuranceIcon.svg'
import { ReactComponent as LiabilityRiskIcon } from 'src/assets/RiskReport_images/liabilityRiskIcon.svg'
import { ReactComponent as TransitRiskIcon } from 'src/assets/RiskReport_images/marineInsuranceIcon.svg'
import { ReactComponent as ProfessionalRiskIcon } from 'src/assets/RiskReport_images/professionalRiskIcon.svg'

const RISK_REPORTS = {
  DOWNLOAD_REPORTS: 'Download Reports',
  DETAILED_RISK_ANALYSIS_REPORT: 'Detailed Risk Analysis Report',
  DETAILED_RISK_ANALYSIS_REPORT_HELPER:
    'of various risks faced by your organization & insurance solutions',
  BAR: 'bar',
  PIE: 'pie',
  VIEW_ALL: 'View All',
  UPCOMING_RENEWALS: 'Upcoming Renewals',
  PREMIUM_PAID: 'Premium Paid',
  EXPIRED: 'Exp',
  EXPIRES_ON: 'Expires on',
  OTHERS: 'Others',
  LINK_BLANK: '_blank',
  TO_LAKHS: 100000,
}
export { RISK_REPORTS }

export const riskCategories = [
  {
    Icon: AssetRiskIcon,
    title: 'Asset',
    value: 'assetRisk',
  },
  {
    Icon: HrRiskIcon,
    title: 'HR',
    value: 'hrRisk',
  },
  {
    Icon: DirectorInsuranceIcon,
    title: 'Director',
    value: 'directorRisk',
  },
  {
    Icon: LiabilityRiskIcon,
    title: 'Liability',
    value: 'liabilityRisk',
  },
  {
    Icon: TransitRiskIcon,
    title: 'Transit',
    value: 'transitRisk',
  },
  {
    Icon: ProfessionalRiskIcon,
    title: 'Professional',
    value: 'professionalRisk',
  },
]

export const GROUP_HEALTH_LIST = [
  'Group Super Top Up Insurance',
  'Group Top-up Insurance',
  'Group OPD Health Insurance',
  'Group Health Insurance',
  'Group Health Insurance (Parents)',
  'Group Critical Illness Insurance',
  'Group Personal Accident Insurance (GPA)',
  'Janata Personal Accident Policy Insurance',
  'Employees Deposit Linked Insurance Scheme (EDLI)',
  'Group Term Life Insurance',
]

export const NOTES =
  'Above analysis is based on data provided by your organization In case of any discrepancy, we request your insurance department to provide us with the missing policies and other details.'

export const CATEGORIES = [
  ['Premium', 'Total'],
  ['Claims', 'Total'],
  ['Paid', 'Claims'],
  ['Outstanding', 'Claims'],
]

export const TAB_TITLES = {
  NEAR_TO_EXPIRE: 'Near To Expire',
  EXPIRED: 'Expired',
  ACTIVE: 'Active',
}

export const columns = [
  {
    field: 'claimsOutstanding',
    headerName: 'Claims Outstanding',
    width: 200,
  },
  { field: 'claimsPaid', headerName: 'Claims Paid', width: 150 },
  { field: 'totalClaims', headerName: 'Total Claims', width: 150 },
  { field: 'totalPremium', headerName: 'Total Premium', width: 150 },
  { field: 'year', headerName: 'Year', width: 100 },
]

export const columnsMarine = [
  { field: 'turnOver', headerName: 'TurnOver', width: 150 },
  { field: 'totalPremium', headerName: 'Total Premium', width: 150 },
  { field: 'totalClaims', headerName: 'Total Claims', width: 150 },
  { field: 'year', headerName: 'Year', width: 100 },
]

export const columnsHealth = [
  { field: 'claimSettled', headerName: 'Claim Settled', width: 150 },
  {
    field: 'claimsOutstanding',
    headerName: 'Claims Outstanding',
    width: 150,
  },
  { field: 'claimsRatio', headerName: 'Claims Ratio', width: 100 },
  {
    field: 'numberOfEmployees',
    headerName: 'Number Of Employees',
    width: 150,
  },
  { field: 'numberOfLives', headerName: 'Number Of Lives', width: 150 },
  { field: 'parentsIncluded', headerName: 'Parents Included', width: 150 },
  { field: 'premiumPaid', headerName: 'Premium Paid', width: 150 },
  { field: 'year', headerName: 'Year', width: 100 },
]

export const INSURANCE = {
  HEALTH: 'health',
  MARINE: 'marine',
}

export const PREMIUM_CLAIMS_OVER = 'Premium & Claims Over '

export const PORTFOLIO_ANALYSIS_OVER = 'PortFolio Analysis Over '

export const TO_LAKHS = 100000
export const CHART_HEIGHT = 210
export const CHART_COLORS = ['#73CFEE', '#EF669B', '#9271BE']
export const TOOLTIP_CONTENT = [
  {
    id: 1,
    content:
      'We strongly suggest comparing the overall expense towards insurance premium in your P&L with the premium shown above.',
  },
  {
    id: 2,
    content:
      'In case of any discrepancy, we request your insurance department to provide us with the missing policies.',
  },
]

export const CLAIMS_AS_ON = 'Claims as on'

export const CLAIM_SYNOPSIS_AS_ON = 'Claims Synopsis as on'

export const PENDINGCLAIM_TYPE = {
  GENERAL_FORM: 'generalForm',
}

export const CLAIM_STATUS = {
  REJECTED: 'REJECTED',
  OUTSTANDING: 'OUTSTANDING',
  SETTLED: 'SETTLED',
}

export const DETAILED_VIEW_TYPES = {
  EMPLOYEE_BENEFIT_CLAIMS: 'EmployeeBenefitsClaims',
  GROUP_ACCIDENTAL: 'groupAccidental',
}

export const CLAIM_AMOUNT_STATUS = {
  OUTSTANDING: 'OUTSTANDING',
  SETTLED: 'SETTLED',
}

export const GRAPH_CONSTANTS = {
  AGE_GRAPH: 'AgeGraph',
}

export const FINANCIAL_CLAIMS_AS_ON = 'Financial Claims as on'

export const FINANCIAL_CLAIM_SYNOPSIS_AS_ON = 'Financial Claims Synopsis as on'

export const FINANCIAL_PREMIUM_CLAIMS_OVER = 'Financial Premium & Claims Over '

export const FINANCIAL_PORTFOLIO_ANALYSIS_OVER =
  'Financial PortFolio Analysis Over '
